import { SORT_ITEMS } from './Sort_items'
import { useArticulosTablePage } from 'context/ArticulosTablePageContext'

const ArticulosFilter = () => {
  const {sort, setSort} = useArticulosTablePage()
  const handleSort = sort => {
    const [field, value] = sort.split('-')
    if (field && value) {
      handleSortChange({ [field]: value === 'asc' ? 1 : -1 })
    }
  }

  const handleSortChange = newSort => {
    const sortKey = Object.keys(newSort)[0]
    const sortOrder = newSort[sortKey] === 1 ? 'asc' : 'dec'

    setSort(`${sortKey}-${sortOrder}`)
  }

  return (
    <div className="articulos-filter">
      <select
        className="articulos-filter__select"
        value={sort}
        onChange={e => handleSort(e.target.value)}
      >
        {SORT_ITEMS.map((item, index) => (
          <option key={index} value={item.value}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default ArticulosFilter
